<template>
  <div class="list-question" v-if="displayStyle == 'list'">
    <div
      class="question"
      v-for="(question, index) in questions"
      v-bind:key="question.id"
      v-bind:class="
        answer[index].num == question.answers.length ? 'disable' : ''
      "
    >
      <p
        v-if="
          question.media &&
          question.media.type == 'image' &&
          question.media.value
        "
        class="image"
      >
        <img :src="question.media.value.src" />
      </p>
      <p class="name">{{ question.text }}</p>
      <p class="description">{{ question.description }}</p>
      <div v-if="!displayAnswer(question)">
        <div
          class="answer"
          v-for="(value, key) in question.options"
          v-bind:key="value.id"
          @click="handleClick(question, value)"
          v-bind:class="[
            answer[index].data.length > 0 &&
            answer[index].data.includes(value.id) &&
            question.answers.includes(value.id)
              ? 'correct'
              : '',
            answer[index].data.length > 0 &&
            answer[index].data.includes(value.id) &&
            !question.answers.includes(value.id)
              ? 'in-correct'
              : '',
          ]"
        >
          <span
            >{{
              settings.script.listStyle == "number" ? key + 1 : mapping[key]
            }})</span
          >
          <span class="value">{{ value.text }}</span>
          <Correct
            v-if="
              question.answers.includes(value.id) ||
              answer[index].num == question.answers.length
            "
            v-bind:class="
              question.answers.includes(value.id) ? 'activeIcon' : ''
            "
          />
          <InCorrect v-if="!question.answers.includes(value.id)" />
        </div>
      </div>
      <div v-else>
        <AnswerImage
          :question="question"
          :index="index"
          :itemWidth="itemWidth"
          :column="column"
        />
      </div>
      <div class="quote" v-if="answer[index].data.length > 0">
        <div v-if="chooseOptionDescription[question.id]">
          <p v-html="chooseOptionDescription[question.id]" />
        </div>
        <div v-if="!chooseOptionDescription[question.id]">
          <img
            v-if="
              question.correct_note &&
              question.correct_note.media &&
              question.correct_note.media.type == 'image' &&
              question.correct_note.media.value
            "
            :src="question.correct_note.media.value.src"
          />
          <p>{{ question.correct_note.text }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="list-question" v-else>
    <div
      class="question"
      v-for="(question, index) in questions"
      v-bind:key="index"
      v-bind:class="
        answer[numQuestion].num == question.answers.length ? 'disable' : ''
      "
    >
      <p
        v-if="
          question.media &&
          question.media.type == 'image' &&
          question.media.value
        "
        class="image"
      >
        <img :src="question.media.value.src" />
      </p>
      <p class="name">{{ question.text }}</p>
      <p class="description">{{ question.description }}</p>
      <div v-if="!displayAnswer(question)">
        <div
          class="answer"
          v-for="(value, key) in question.options"
          v-bind:key="value.id"
          @click="handleClick(question, value)"
          v-bind:class="[
            answer[numQuestion].data.length > 0 &&
            answer[numQuestion].data.includes(value.id) &&
            question.answers.includes(value.id)
              ? 'correct'
              : '',
            answer[numQuestion].data.length > 0 &&
            answer[numQuestion].data.includes(value.id) &&
            !question.answers.includes(value.id)
              ? 'in-correct'
              : '',
          ]"
        >
          <span
            >{{
              settings.script.listStyle == "number" ? key + 1 : mapping[key]
            }})</span
          >
          <span class="value">{{ value.text }}</span>
          <Correct
            v-if="
              question.answers.includes(value.id) ||
              answer[numQuestion].num == question.answers.length
            "
            v-bind:class="
              question.answers.includes(value.id) ? 'activeIcon' : ''
            "
          />
          <InCorrect v-if="!question.answers.includes(value.id)" />
        </div>
      </div>
      <div v-else>
        <AnswerImage
          :question="question"
          :index="numQuestion"
          :itemWidth="itemWidth"
          :column="column"
          :click="setChooseOptionDescription"
        />
      </div>
      <div class="quote" v-if="answer[index].data.length > 0">
        <div v-if="chooseOptionDescription[question.id]">
          <p v-html="chooseOptionDescription[question.id]" />
        </div>
        <div v-if="!chooseOptionDescription[question.id]">
          <img
            v-if="
              question.correct_note &&
              question.correct_note.media &&
              question.correct_note.media.type == 'image' &&
              question.correct_note.media.value
            "
            :src="question.correct_note.media.value.src"
          />
          <p>{{ question.correct_note.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InCorrect from "../../ui/icons/svgs/icons/InCorrect";
import Correct from "../../ui/icons/svgs/icons/Correct";
import AnswerImage from "./AnswerImage";

export default {
  name: "Question",
  props: ["questions", "itemWidth", "column"],
  components: {
    InCorrect,
    Correct,
    AnswerImage,
  },
  data: function () {
    return {
      mapping: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "W",
        "T",
        "U",
        "V",
        "X",
        "Y",
        "Z",
      ],
      settings: this.$store.getters.quiz.settings || {},
      chooseOptionDescription: {},
    };
  },
  computed: {
    displayStyle: function () {
      return this.$store.getters.quiz.settings.script.displayStyle;
    },
    answer: function () {
      return this.$store.getters.defaultAnswer;
    },
    numQuestion: function () {
      return this.$store.getters.getNumQuestion;
    },
  },
  methods: {
    setChooseOptionDescription(question, option) {
      this.chooseOptionDescription[question.id] = option.description;
    },
    handleClick(question, option) {
      const infoChoose = [
        question.id,
        option.id,
        question.kind,
        question.answers.length,
      ];
      this.$store.dispatch("addAnswer", infoChoose);
      this.chooseOptionDescription[question.id] = option.description;
    },
    displayAnswer(question) {
      let flag = false;
      question.options.filter((ans) =>
        ans.media != null ? (flag = true) : ""
      );
      return flag;
    },
  },
  mounted() {
    this.$store.getters.quiz.addChangeListener("settings", (value) => {
      this.settings = value;
    });
  },
};
</script>
